/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const PurchasePendingLock = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 49 49" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M31.87 21.77h-.17v-3a7.2 7.2 0 1 0-14.4 0v3h-.17a1.51 1.51 0 0 0-1.63 1.43v10.87a1.51 1.51 0 0 0 1.63 1.43h14.74a1.51 1.51 0 0 0 1.63-1.43V23.2a1.51 1.51 0 0 0-1.63-1.43m-7.37-6.88a3.64 3.64 0 0 1 3.6 3.88v3h-7.2v-3a3.64 3.64 0 0 1 3.6-3.88m1.6 14.93a1.6 1.6 0 0 1-3.2 0c0-.54-.2-1 .7-1.3v-2.83a.9.9 0 1 1 1.8 0v2.83c.9.29.7.76.7 1.3" />
      </g>
    </svg>
  </span>
);

PurchasePendingLock.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

PurchasePendingLock.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default PurchasePendingLock;
